module.exports = __webpack_public_path__ + "static/media/nurturing.fb704480.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/learn/nurturing.svg
// module id = 584
// module chunks = 31